import Vue from 'vue';
import VueRouter from 'vue-router';

import {ROUTER_MODE} from '../config/app'

import Err401 from '../views/401'
import NotFound from '../views/404.vue'
import Login from '../views/Login.vue'
import System from '../views/System.vue'
import ForgetPassword from "../views/setting/ForgetPassword";
import MemberRegisterFirst from "../views/setting/MemberRegisterFirst";
import MemberRegisterSecond from "../views/setting/MemberRegisterSecond";
import WeChatRegister from "../views/setting/WeChatRegister";
import MemberEditInfo from "../views/mine/MemberEditInfo";
import Home from "../views/home/Home";
import Order from "../views/order/Order";
import Mine from "../views/mine/Mine";
import Index from "../views/Index";
import AddressList from "../views/mine/AddressList";
import AddressAdd from "../views/mine/AddressAdd";
import MemberPrintingDetail from "../views/mine/MemberPrintingDetail";
import OrderDetail from "../views/order/OrderDetail";
import SelectAddress from "../views/order/SelectAddress";
import PlaceOrder from "../views/home/PlaceOrder";
import StampExchange from "../views/mine/StampExchange";
import AddressChoose from "../views/order/AddressChoose";
import StampExchangeReport from "../views/mine/StampExchangeReport";
import OrderSuccess from "../views/order/OrderSuccess";
import Activity from "../views/activity/Activity.vue";
import ActivityAddressAdd from "../views/activity/ActivityAddressAdd.vue";
import VerifyAddress from "../views/activity/VerifyAddress.vue";
import PackagePlaceOrder from "../views/home/PackagePlaceOrder.vue";
import PackagePeriodOrderDetail from "../views/packageOrder/PackagePeriodOrderDetail.vue";
import PackageOrderSuccess from "../views/packageOrder/PackageOrderSuccess.vue";
import StampShop from "../views/stampShop/StampShop.vue";
// import PeachLottery from "../views/peachLottery/PeachLottery.vue";
import StampExchangePage from "../views/stampShop/StampExchange.vue";
import StampExchangeDetail from "../views/stampShop/StampExchangeDetail.vue";
import StampExchangeConfirm from "../views/stampShop/StampExchangeConfirm.vue";
import Lottery from "../views/stampShop/Lottery.vue";
import StampLottery from "../views/stampShop/StampLottery.vue";
import ClockInLottery from "../views/stampShop/ClockInLottery.vue";
import StampShopDetail from "../views/stampShop/StampShopDetail.vue";
import ExchangeRecord from "../views/stampShop/ExchangeRecord.vue";
import StampUsageRecord from "../views/stampShop/StampUsageRecord.vue";

Vue.use(VueRouter);

export const constantRouterMap = [
    {
        path: '/',
        component: Login,
        name: 'login',
        hidden: true,
        meta: {
            title: '广州益力多',
            keepAlive: false,
        },
    },
    {
        path: '*',
        component: NotFound,
        hidden: true,
        meta: {
            title: '广州益力多',
            keepAlive: false,
        },
    },
    {
        path: '/401',
        component: Err401,
        name: '401',
        hidden: true,
        meta: {
            title: '广州益力多',
            keepAlive: false,
        },
    },
    {
        path: '/404',
        component: NotFound,
        name: '404',
        hidden: true,
        meta: {
            title: '广州益力多',
            keepAlive: false,
        },
    },
    {
        path: '/500',
        component: NotFound,
        name: '500',
        hidden: true,
        meta: {
            title: '广州益力多',
            keepAlive: false,
        },
    },
    {
        path: '/system',
        component: System,
        name: 'System',
        hidden: true,
        meta: {
            meta: '系统维护',
            keepAlive: false,
        },
    },
    {
        path: '/homeMain',
        component: Index,
        name: 'Index',
        meta: {
            title: '广州益力多',
            keepAlive: true,
        },
        children: [
            {
                path: '/home',
                component: Home,
                meta: {
                    title: '在线订购',
                    keepAlive: false,
                },
            },
            // {
            //     path: '/package/order',
            //     component: PackageOrder,
            //     meta: {
            //         title: '我的加价购',
            //         keepAlive: true,
            //     },
            // },
            {
                path: '/order',
                component: Order,
                meta: {
                    title: '我的订单',
                    keepAlive: true,
                },
            },
            {
                path: '/stampShop',
                component: StampShop,
                meta: {
                    title: '印花商城',
                    keepAlive: false,
                },
            },
            // {
            //     path: '/peachLottery',
            //     component: PeachLottery,
            //     meta: {
            //         title: '水蜜桃抽奖',
            //         keepAlive: false,
            //     },
            // },
            {
                path: '/mine',
                component: Mine,
                meta: {
                    title: '个人中心',
                    keepAlive: false,
                },
            }
        ]
    },
    {
        path: '/forgetPassword',
        component: ForgetPassword,
        name: 'ForgetPassword',
        meta: {
            title: '广州益力多',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/registerMemberFirst',
        component: MemberRegisterFirst,
        name: 'MemberRegisterFirst',
        meta: {
            title: '益力多注册',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/registerMemberSecond',
        component: MemberRegisterSecond,
        name: 'MemberRegisterSecond',
        meta: {
            title: '益力多注册',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/weChatRegisterMember',
        component: WeChatRegister,
        name: 'WeChatRegister',
        meta: {
            title: '广州益力多',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/memberEditInfo',
        component: MemberEditInfo,
        name: 'MemberEditInfo',
        meta: {
            title: '广州益力多',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/addressList',
        component: AddressList,
        name: 'AddressList',
        meta: {
            title: '收货地址',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/addressAdd',
        component: AddressAdd,
        name: 'AddressAdd',
        meta: {
            title: '添加收货地址',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/memberPrintingDetail',
        component: MemberPrintingDetail,
        name: 'MemberPrintingDetail',
        meta: {
            title: '广州益力多',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/orderDetail',
        component: OrderDetail,
        name: 'OrderDetail',
        meta: {
            title: '订单详情',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/selectAddress',
        component: SelectAddress,
        name: 'SelectAddress',
        meta: {
            title: '广州益力多',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/placeOrder',
        component: PlaceOrder,
        name: 'PlaceOrder',
        hidden: true,
        meta: {
            title: '确认下单',
            keepAlive: false,
        }
    },
    {
        path: '/packagePlaceOrder',
        component: PackagePlaceOrder,
        name: 'PackagePlaceOrder',
        hidden: true,
        meta: {
            title: '确认下单',
            keepAlive: false,
        }
    },
    {
        path: '/stampExchange',
        component: StampExchange,
        name: 'StampExchange',
        meta: {
            title: '广州益力多',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/addressChoose',
        component: AddressChoose,
        name: 'AddressChoose',
        meta: {
            title: '广州益力多',
            keepAlive: true,
        },
        hidden: true
    },
    {
        path: '/stampExchangeReport',
        component: StampExchangeReport,
        name: 'StampExchangeReport',
        meta: {
            title: '广州益力多',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/orderSuccess',
        component: OrderSuccess,
        name: 'OrderSuccess',
        meta: {
            title: '下单成功',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/activity',
        component: Activity,
        name: 'Activity',
        meta: {
            title: '活动',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/activityAddressAdd',
        component: ActivityAddressAdd,
        name: 'ActivityAddressAdd',
        meta: {
            title: '收货信息',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/verifyAddress',
        component: VerifyAddress,
        name: 'VerifyAddress',
        meta: {
            title: '确认收货信息',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/packageOrderSuccess',
        component: PackageOrderSuccess,
        name: 'PackageOrderSuccess',
        meta: {
            title: '下单成功',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/packagePeriodOrderDetail',
        component: PackagePeriodOrderDetail,
        name: 'PackagePeriodOrderDetail',
        meta: {
            title: '套餐订单详情',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/stampExchangePage',
        component: StampExchangePage,
        name: 'StampExchangePage',
        meta: {
            title: '印花兑换',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/stampExchangeDetail',
        component: StampExchangeDetail,
        name: 'StampExchangeDetail',
        meta: {
            title: '兑换商品详情',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/stampExchangeConfirm',
        component: StampExchangeConfirm,
        name: 'StampExchangeConfirm',
        meta: {
            title: '确认兑换',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/lottery',
        component: Lottery,
        name: 'Lottery',
        meta: {
            title: '抽奖',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/stampLottery',
        component: StampLottery,
        name: 'StampLottery',
        meta: {
            title: '印花抽奖',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/clockInLottery',
        component: ClockInLottery,
        name: 'ClockInLottery',
        meta: {
            title: '打卡抽奖',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/stampShopDetail',
        component: StampShopDetail,
        name: 'StampShopDetail',
        meta: {
            title: '印花商城详情',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/exchangeRecord',
        component: ExchangeRecord,
        name: 'ExchangeRecord',
        meta: {
            title: '中奖/兑换券',
            keepAlive: false,
        },
        hidden: true
    },
    {
        path: '/stampUsageRecord',
        component: StampUsageRecord,
        name: 'StampUsageRecord',
        meta: {
            title: '印花使用记录',
            keepAlive: false,
        },
        hidden: true
    }

];

export default new VueRouter({
    mode: ROUTER_MODE,
    routes: constantRouterMap,
    scrollBehavior: () => ({y: 0}),
});

export const asyncRouterMap =
    {
        //首页
        // '/dashboard': () => import('@/views/home/HomeMain'),


    };
